// Copyright (c) Ensho Health, 2022 to present

import api from '../api';
import { setNotification, NOTIFICATION_TYPES } from './notification.action.js';

const PREFIX = 'cdl-services';
export const ACTION_TYPES = {
  SET_CDL_SERVICES: `${PREFIX}-SET_CDL_SERVICES`,
  LOADING: `${PREFIX}-LOADING`,
  ERROR: `${PREFIX}-ERROR`
};

export function fetchCdlServices() {
  return async (dispatch) => {
    try {
      dispatch({ type: ACTION_TYPES.LOADING });
      const res = await api.cdlServices.fetchCdlServices();
      dispatch({
        type: ACTION_TYPES.SET_CDL_SERVICES,
        payload: res
      });
    } catch (error) {
      console.error(error.message);
      dispatch(
        setNotification({
          type: NOTIFICATION_TYPES.ERROR,
          serverMessage: error.message,
          info: { location: 'cdl-services.action.fetchCdlServices' },
          display: 'Error while fetching cdl services'
        })
      );
      dispatch({ type: ACTION_TYPES.ERROR, payload: error.message });
    }
  };
}
